module.exports = __webpack_public_path__ + "static/media/icon-back.d2adab35.svg";